<template>
    <div
        :style="`height:${height}px; width:${width}px`"
    >
        <canvas
            ref="canvas"
        ></canvas>
    </div>
</template>

<script>
import {Chart as ChartJS} from 'chart.js';


import {BoxPlotChart} from '@sgratzl/chartjs-chart-boxplot';

export default {
    name: 'BoxPlotChart',
    components: {
        BoxPlotChart
    },
    props: {
        chartData: {
            type: Object,
            required: true
        },
        xAxesLabelString: {
            type: String,
            required: true
        },
        yAxesLabelString: {
            type: String,
            required: true
        },
        height: {
            type: Number,
            default: 350
        },
        width: {
            type: Number,
            default: 350
        }
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        const ctx = this.$refs.canvas.getContext('2d');
        const yAxesList = this.yAxesLabelString.replace('Median ', '').split('<br>');

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                    labels: {
                        font: {
                            family: "'Source Sans Pro'",
                            size: 13
                        }
                    }
                },
                tooltip: {
                    callbacks: {
                        label: tooltipItem => {
                            const label = tooltipItem.dataset.label || '';
                            const y = tooltipItem.raw?.y ?? tooltipItem.parsed.y;
                            return label ? `${label}: ${y}` : `${y}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: this.xAxesLabelString,
                        font: {
                            family: "'Source Sans Pro'",
                            size: 13
                        }
                    },
                    ticks: {
                        font: {
                            family: "'Source Sans Pro'",
                            size: 13
                        }
                    }
                },
                y: {
                    type: 'linear',
                    position: 'left',
                    ticks: {
                        callback: value => value.toString().replace('.', ','),
                        font: {
                            family: "'Source Sans Pro'",
                            size: 13
                        }
                    },
                    title: {
                        display: true,
                        text: yAxesList.length === 2 ? yAxesList[1] : yAxesList[0],
                        font: {
                            family: "'Source Sans Pro'",
                            size: 13
                        }
                    }
                }
            }
        };

        if (yAxesList.length === 2) {
            options.scales.y1 = {
                type: 'linear',
                position: 'left',
                display: true,
                grid: {
                    display: false,
                    color: 'transparent'
                },
                ticks: {
                    display: false
                },
                title: {
                    display: true,
                    text: yAxesList[0],
                    font: {
                        family: "'Source Sans Pro'",
                        size: 13
                    }
                }
            };
        }

        this.chart = new ChartJS(ctx, {
            type: 'boxplot',
            data: this.chartData,
            options
        });
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
};
</script>

<style scoped>
canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
